var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ad-container sticky-top d-none d-md-block"},[_c('transition',{attrs:{"name":"fade"}},[_c('img',{key:_vm.currentAd,staticClass:"ad-single",attrs:{"src":_vm.currentAd,"alt":"Ebola Ad"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }